<template>
  <swiper
      class="stories-menu-slider"
      slides-per-view="auto"
  >
    <swiper-slide
        class="stories-menu-slider__item"
        v-for="(story, index) in stories"
        :key="story.id"
        @click="openStory(index)"
    >
      <div class="stories-menu-slider__item-title text-center">
        <img class="stories-menu-slider__item-img" :src="story.thumbnail" :alt="story.title">
        <div class=" stories-menu-slider_item_image_description">
          {{ story.title }}
        </div>
      </div>
    </swiper-slide>
  </swiper>
</template>

<script>
import {Swiper, SwiperSlide} from 'swiper/vue';
import 'swiper/css';

export default {
  name: "StoriesMenuSlider",
  components: {Swiper, SwiperSlide},
  props: {
    stories: {}
  },
  methods: {
    openStory(index) {
      this.$emit('selectedStory', {index: index, isStoriesActive: true})
    }
  }

}
</script>

<style scoped>
.stories-menu-slider {
  overflow: visible;
}

.stories-menu-slider__item {
  width: 12rem;
  height: 12rem;
  cursor: pointer;
}

@media only screen and (max-width: 991px) {
  .stories-menu-slider__item {
  }
}

@media only screen and (max-width: 767px) {
  .stories-menu-slider__item {
    width: 11rem;
    height: 11rem;
  }
}

.stories-menu-slider__item:not(:last-child) {
  margin-right: 0rem;
}

.stories-menu-slider__item-img {
  width: 150px;
  height: 150px;
  object-fit: cover;
  border-radius: 50%;
  display: inline-block;
  border: 3px solid var(--primary);
  padding: 5px;
}

.stories-menu-slider__item-title {
  font-size: 2rem;
  line-height: 1.2;
}

@media only screen and (max-width: 767px) {
  .stories-menu-slider__item-title {
    font-size: 16px;
  }
}

.stories-menu-slider_item_image_description {
  font-size: 12px;
  margin-top: 10px;
}

</style>